import { z } from 'zod';
import { I18nStringSchema } from '../../core/i18n';
import { BaseRemedySchema } from '../remedy/remedy';
import { ImageAssetSchema } from '../ui/imageAsset';
import { RemedyPairSchema } from './remedyPairings';
import { ResourceSchema } from './resource';
import { TipSchema } from './tip';
export const BaseRemedyReferenceSchema = BaseRemedySchema.extend({
    hero: ImageAssetSchema.optional(),
    longDescriptionI18n: I18nStringSchema,
    costSummaryI18n: I18nStringSchema.optional(),
    tips: z.array(TipSchema),
    resources: z.array(ResourceSchema),
    pairings: z.array(RemedyPairSchema)
});
//# sourceMappingURL=remedy.js.map